import { FormControl, FormGroup } from '@angular/forms';
import { Entity, ImageModel, Nullable } from '@pin-up-global/common';
import { ChatMessage } from '@shared/chat';

export enum FeedbackStatus {
  New = 'new',
  InProgress = 'in_progress',
  Processed = 'processed',
}

export interface Feedback extends Entity {
  botId: number;
  adminUserEmail?: Nullable<string>;
  status: FeedbackStatus;
  receivedAt: string;
  items: ChatMessage[];
}

export interface FeedbackDialogData {
  feedbackId: number;
  userId: number;
}

export interface FeedbackAdminResp {
  images: Nullable<string[]>;
  text: string;
}

export interface FeedbackForm {
  text: FormControl<string>;
  images: FormControl<Nullable<ImageModel[]>>;
}

export interface FeedbacksFiltersForm {
  search: FormControl<Nullable<string>>;
  receivedAtStart: FormControl<Nullable<string>>;
  receivedAtEnd: FormControl<Nullable<string>>;
  status: FormControl<Nullable<FeedbackStatus>>;
};
